(function () {
  function initializePacificaHeader() {
    const scope = document.querySelector('.pacifica-global-header');
    if (!scope || scope.dataset.headerInitialized === 'true') return;
    scope.dataset.headerInitialized = 'true';

    const siteHeader = scope.querySelector('#siteHeader');
    const menuButton = scope.querySelector('#menuButton');
    const mobileMenu = scope.querySelector('#mobileMenu');
    const shopMenuButton = scope.querySelector('#shopMenuButton');
    const shopMegaMenu = scope.querySelector('#shopMegaMenu');

    function updateStickyHeader() {
      const threshold = window.innerWidth < 768 ? 0 : 24;
      siteHeader.classList.toggle('is-scrolled', window.scrollY > threshold);
    }

    function closeShopMenu(returnFocus) {
      if (shopMegaMenu.hidden) return;
      shopMegaMenu.hidden = true;
      shopMenuButton.setAttribute('aria-expanded', 'false');
      if (returnFocus) shopMenuButton.focus();
    }

    function closeMobileMenu(returnFocus) {
      if (mobileMenu.classList.contains('hidden')) return;
      mobileMenu.classList.add('hidden');
      menuButton.setAttribute('aria-expanded', 'false');
      menuButton.setAttribute('aria-label', 'Open menu');
      document.documentElement.classList.remove('pacifica-mobile-menu-open');
      if (returnFocus) menuButton.focus();
    }

    menuButton.addEventListener('click', function () {
      const isOpen = mobileMenu.classList.contains('hidden');
      mobileMenu.classList.toggle('hidden', !isOpen);
      menuButton.setAttribute('aria-expanded', String(isOpen));
      menuButton.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');
      document.documentElement.classList.toggle('pacifica-mobile-menu-open', isOpen);
    });
    mobileMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { closeMobileMenu(false); });
    });
    shopMenuButton.addEventListener('click', function () {
      const willOpen = shopMegaMenu.hidden;
      shopMegaMenu.hidden = !willOpen;
      shopMenuButton.setAttribute('aria-expanded', String(willOpen));
    });
    shopMegaMenu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', function () { closeShopMenu(false); });
    });
    document.addEventListener('click', function (event) {
      if (!shopMegaMenu.hidden && !shopMegaMenu.contains(event.target) && !shopMenuButton.contains(event.target)) closeShopMenu(false);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      if (!mobileMenu.classList.contains('hidden')) closeMobileMenu(true);
      else if (!shopMegaMenu.hidden) closeShopMenu(true);
    });
    window.addEventListener('resize', function () {
      if (window.innerWidth < 1024) closeShopMenu(false);
      else closeMobileMenu(false);
    });
    updateStickyHeader();
    window.addEventListener('scroll', updateStickyHeader, { passive: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initializePacificaHeader);
  else initializePacificaHeader();
  document.addEventListener('shopify:section:load', initializePacificaHeader);
}());
